<template>
	<div class="co-banner" :class="'co-banner--' + version">
		<div class="co-banner__wrapper">
			<div class="spacer"></div>

			<div class="carousel" v-if="!override">
				<div class="message" v-for="(item, index) in announcements">
					<Transition name="fade">
						<p v-if="current == index + 1">
							{{ item }}
						</p>
					</Transition>
				</div>
			</div>

			<div v-if="override" class="important" ref="holder">
				<marquee class="important__marq" direction="left" loop="" ref="marquee">
					<p :class="!this.overflown ? 'static-text' : ''">
						{{ importantInformation }}
					</p>
				</marquee>
				<div class="important__gradient"></div>
			</div>
			<slot name="selector"></slot>
		</div>
	</div>
</template>

<script>
import ArrowIcon from '@web/assets/icon/arrow.svg';

export default {
	name: 'Banner',
	props: {
		announcements: {
			type: Array,
			default: [],
		},
		importantInformation: {
			type: String,
			default: '',
		},
		version: {
			type: String,
			default: '',
		},
	},
	components: {
		ArrowIcon,
	},
	data: () => {
		return {
			override: false,
			overflown: false,

			current: 1,
		};
	},
	methods: {
		fadeOut() {
			if (!this.override) {
				setTimeout(() => {
					this.current++;

					if (this.current > this.announcements.length) {
						this.current = 1;
					}

					this.fadeOut();
				}, 4000);
			}
		},
		isOverflown(marquee, holder) {
			if (this.override) {
				if (marquee.scrollWidth > holder.clientWidth) {
					this.overflown = true;
				}
			}
		},
	},
	created() {
		if (this.importantInformation) {
			this.override = true;
		}
		this.fadeOut();
	},
	mounted() {
		this.isOverflown(this.$refs.marquee, this.$refs.holder);
		if (!this.overflown) {
			this.$refs.marquee?.stop();
		}
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.co-banner {
	height: 48px;
	background-color: $c-pink-secondary;
	border-bottom: $e-border;

	&__wrapper {
		@include grid-keep();
		display: flex;
		height: 100%;
	}

	.spacer,
	.o-siteSelector {
		@include size-fix(90px);
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.carousel {
		width: 100%;
		display: flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		height: 100%;
		position: relative;

		.message {
			height: 100%;
			text-align: center;
			align-items: center;
			justify-content: center;
			display: flex;

			position: absolute;
			width: 100%;

			text-transform: uppercase;

			p {
				font-weight: $f-semibold;
				@include text-overflow(1);
			}
		}
	}

	&--important {
		background-color: $c-pink-secondary;
		.important {
			flex: 1;
			height: 100%;
			max-width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-inline: 30px;
			position: relative;
			overflow: hidden;

			p {
				color: $c-blue;
				font-weight: 500;
			}
			.static-text {
				text-align: center;
			}

			&__gradient {
				position: absolute;
				left: 0;
				top: 0;
				z-index: 5;
				width: 100%;
				height: 100%;
				background: linear-gradient(
					90deg,
					$c-pink-secondary 2%,
					rgba(0, 0, 0, 0) 5%,
					rgba(0, 0, 0, 0) 95%,
					$c-pink-secondary 98%
				);
			}
			&--active {
				overflow: hidden;
				padding-right: 100px;
			}
		}
	}
}

@media all and (max-width: 768px) {
	.co-banner {
		height: 31px;
		&__wrapper {
			.spacer {
				display: none;
			}
			.o-siteSelector {
				display: none;
			}
		}
		&--important {
			background-color: $c-pink-secondary;
			.important {
				margin-inline: 0px;
				p {
					font-size: 13px;
				}
			}
		}
	}
}
</style>
